var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconPlay18 = function SvgAIconPlay18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8277 7.77705L6.8385 3.24779C5.83792 2.59938 4.5 3.29907 4.5 4.47075L4.5 13.5293C4.5 14.7009 5.83792 15.4006 6.83849 14.7522L13.8277 10.223C14.7241 9.64205 14.7241 8.35795 13.8277 7.77705Z"
  })));
};
export { SvgAIconPlay18 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTMuODI3NyA3Ljc3NzA1TDYuODM4NSAzLjI0Nzc5QzUuODM3OTIgMi41OTkzOCA0LjUgMy4yOTkwNyA0LjUgNC40NzA3NUw0LjUgMTMuNTI5M0M0LjUgMTQuNzAwOSA1LjgzNzkyIDE1LjQwMDYgNi44Mzg0OSAxNC43NTIyTDEzLjgyNzcgMTAuMjIzQzE0LjcyNDEgOS42NDIwNSAxNC43MjQxIDguMzU3OTUgMTMuODI3NyA3Ljc3NzA1WiIvPgo8L3N2Zz4K";